import "stylesheets_v2/application";
import "../../vendor/gecko-sort";

import Rails from "@rails/ujs";
import money from "money";

import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import { initializeAlpine } from "../alpine";
import { initializeAnyCable } from "../anycable";
import { initializeFlashMessages } from "../flash_messages";


// @rails/ujs: https://guides.rubyonrails.org/v6.1/working_with_javascript_in_rails.html
window.Rails = Rails;
Rails.start();

// Alias window.fx to money.js to handle conversions between currencies
window.fx = money;


const application = Application.start();
const context = require.context("controllers_v2/global", false, /.js$/);
const adsContext = require.context("controllers_v2/shared/ads", false, /.js$/);
const sharedContext = require.context("controllers_v2/shared", false, /.js$/);
const searchContext = require.context("controllers_v2", false, /search_.*controller.js$/);

initializeAlpine();
application.load(definitionsFromContext(context));
application.load(definitionsFromContext(adsContext));
application.load(definitionsFromContext(sharedContext));
application.load(definitionsFromContext(searchContext));

initializeAnyCable();
initializeFlashMessages();
